import { defaultText } from '@phaser/helpers/Text';
import { DEPTH } from '@phaser/data/depth';
import { Game } from '@phaser/scenes/Game';
import i18next from 'i18next';

export class ContinueSystem {
  private _scene = Game.current;

  private _timeLeft = 0;

  private _continueButton?: Phaser.GameObjects.Container;
  private _closeButton?: Phaser.GameObjects.Container;
  private _background?: Phaser.GameObjects.Rectangle;
  private _infoText?: Phaser.GameObjects.Text;
  private _timer?: Phaser.GameObjects.Text;

  constructor() {}

  public update(_time: number, delta: number) {
    this._updateTimer(delta);
  }

  public show() {
    this._timeLeft = 10_000;
    if (!this._timer) this._createTimer();
  }

  public destroy() {
    this._timeLeft = 0;

    this._timer?.destroy();
    this._timer = undefined;
    this._infoText?.destroy();
    this._infoText = undefined;
    this._background?.destroy();
    this._background = undefined;
    this._closeButton?.destroy();
    this._closeButton = undefined;
    this._continueButton?.destroy();
    this._continueButton = undefined;
  }

  private async _createTimer() {
    const camera = this._scene.cameras.main;
    const width = camera.displayWidth;
    const height = camera.displayHeight;

    this._background = this._scene.add.rectangle(0, 0, width, height, 0x000000, 0.9)
      .setDepth(DEPTH.RESPAWN_BACKGROUND)
      .setOrigin(0);

    const text = i18next.t('Game.continue');

    this._infoText = this._scene.add.text(width / 2, height / 2 - 164, text, {
      ...defaultText,
      strokeThickness: 0,
      fontSize: '24px',
    })
    .setOrigin(0.5)
    .setDepth(DEPTH.RESPAWN);

    this._timer = this._scene.add.text(width / 2, height / 2 - 132, '00:00', {
      fontFamily: 'Kode Mono Variable',
      fontSize: '32px',
      color: '#ffffff',
      resolution: 3,
    })
    .setOrigin(0.5)
    .setDepth(DEPTH.RESPAWN)
    .setAlpha(1);

    await new Promise(r => setTimeout(r, 1000));

    const maxButtonWidth = Math.min(width / 1.3, 300);

    this._closeButton = this._scene.add.container(width / 2, height / 2).setDepth(DEPTH.RESPAWN);
    const closeButtonBG = this._scene.add.rectangle(0, 0, maxButtonWidth, 100, 0xFFFFFF, 0.2)
      .setInteractive();
    const closeButtonText = this._scene.add.text(0, 0, i18next.t('Game.leaveBtn'), {
      ...defaultText,
      fontSize: '24px',
    }).setOrigin(0.5);
    this._closeButton.add([closeButtonBG, closeButtonText]);

    closeButtonBG.on('pointerdown', () => {
      this._scene.multiplayerSystem.leaveGame();
    });

    this._continueButton = this._scene.add.container(width / 2, height / 2 + 125).setDepth(DEPTH.RESPAWN);
    const continueButtonBG = this._scene.add.rectangle(0, 0, maxButtonWidth, 100, 0xFFFFFF, 0.2)
      .setInteractive();
    const continueButtonText = this._scene.add.text(0, 0, i18next.t('Game.continueBtn'), {
      ...defaultText,
      fontSize: '24px',
    }).setOrigin(0.5);
    this._continueButton.add([continueButtonBG, continueButtonText]);

    continueButtonBG.on('pointerdown', () => {
      this._scene.multiplayerSystem.continue();
      this.destroy();
    });
  }

  private _updateTimer(delta: number) {
    if (this._timeLeft <= 0) return;

    this._timeLeft -= delta;
    if (this._timeLeft <= 0) return this.destroy();

    const seconds = Math.floor(this._timeLeft / 1000);
    const milliseconds = Math.floor(this._timeLeft % 1000);
    const ss = seconds.toString().padStart(2, '0');
    const mmm = milliseconds.toString().padStart(3, '0');
  
    this._timer?.setText(`${ss}:${mmm}`);
  }
}